<template>
  <b-card no-body class="p-2 border-bottom">
    <div class="row">
      <div class="col-md-1">
        <svg-vue
          v-if="details.extension === '7zip'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.7zip"
        />
        <svg-vue
          v-else-if="details.extension === 'ace'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.ace"
        />
        <svg-vue
          v-else-if="details.extension === 'aep'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.aep"
        />
        <svg-vue
          v-else-if="details.extension === 'aepx'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.aepx"
        />
        <svg-vue
          v-else-if="details.extension === 'aet'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.aet"
        />
        <svg-vue
          v-else-if="details.extension === 'ai'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.ai"
        />
        <svg-vue
          v-else-if="details.extension === 'ait'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.ait"
        />
        <svg-vue
          v-else-if="details.extension === 'avi'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.avi"
        />
        <svg-vue
          v-else-if="details.extension === 'bmp'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.bmp"
        />
        <svg-vue
          v-else-if="details.extension === 'c'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.c"
        />
        <svg-vue
          v-else-if="details.extension === 'css'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.css"
        />
        <svg-vue
          v-else-if="details.extension === 'doc'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.doc"
        />
        <svg-vue
          v-else-if="details.extension === 'docx'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.docx"
        />
        <svg-vue
          v-else-if="details.extension === 'dotx'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.dotx"
        />
        <svg-vue
          v-else-if="details.extension === 'eps'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.eps"
        />
        <svg-vue
          v-else-if="details.extension === 'flv'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.flv"
        />
        <svg-vue
          v-else-if="details.extension === 'gif'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.gif"
        />
        <svg-vue
          v-else-if="details.extension === 'html'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.html"
        />
        <svg-vue
          v-else-if="details.extension === 'java'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.java"
        />
        <svg-vue
          v-else-if="details.extension === 'jpeg'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.jpeg"
        />
        <svg-vue
          v-else-if="details.extension === 'jpg'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.jpg"
        />
        <svg-vue
          v-else-if="details.extension === 'js'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.js"
        />
        <svg-vue
          v-else-if="details.extension === 'less'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.less"
        />
        <svg-vue
          v-else-if="details.extension === 'm4a'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.m4a"
        />
        <svg-vue
          v-else-if="details.extension === 'mid'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.mid"
        />
        <svg-vue
          v-else-if="details.extension === 'mp3'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.mp3"
        />
        <svg-vue
          v-else-if="details.extension === 'mp4'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.mp4"
        />
        <svg-vue
          v-else-if="details.extension === 'mpg'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.mpg"
        />
        <svg-vue
          v-else-if="details.extension === 'odf'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.odf"
        />
        <svg-vue
          v-else-if="details.extension === 'ods'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.ods"
        />
        <svg-vue
          v-else-if="details.extension === 'odt'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.odt"
        />
        <svg-vue
          v-else-if="details.extension === 'otp'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.otp"
        />
        <svg-vue
          v-else-if="details.extension === 'ots'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.ots"
        />
        <svg-vue
          v-else-if="details.extension === 'ott'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.ott"
        />
        <svg-vue
          v-else-if="details.extension === 'pdf'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.pdf"
        />
        <svg-vue
          v-else-if="details.extension === 'php'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.php"
        />
        <svg-vue
          v-else-if="details.extension === 'png'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.png"
        />
        <svg-vue
          v-else-if="details.extension === 'ppt'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.ppt"
        />
        <svg-vue
          v-else-if="details.extension === 'pptx'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.pptx"
        />
        <svg-vue
          v-else-if="details.extension === 'psd'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.psd"
        />
        <svg-vue
          v-else-if="details.extension === 'py'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.py"
        />
        <svg-vue
          v-else-if="details.extension === 'qt'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.qt"
        />
        <svg-vue
          v-else-if="details.extension === 'rar'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.rar"
        />
        <svg-vue
          v-else-if="details.extension === 'raw'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.raw"
        />
        <svg-vue
          v-else-if="details.extension === 'svg'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.svg"
        />
        <svg-vue
          v-else-if="details.extension === 'tga'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.tga"
        />
        <svg-vue
          v-else-if="details.extension === 'tgz'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.tgz"
        />
        <svg-vue
          v-else-if="details.extension === 'txt'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.txt"
        />
        <svg-vue
          v-else-if="details.extension === 'wav'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.wav"
        />
        <svg-vue
          v-else-if="details.extension === 'xls'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.xls"
        />
        <svg-vue
          v-else-if="details.extension === 'xlsx'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.xlsx"
        />
        <svg-vue
          v-else-if="details.extension === 'xml'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.xml"
        />
        <svg-vue
          v-else-if="details.extension === 'zip'"
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.zip"
        />
        <svg-vue
          v-else
          style="width: 1.8rem; height: 1.8rem"
          icon="file-extension.default"
        />
      </div>
      <div class="col-md-9">
        <b>{{ details.name }}</b>
        <small class="text-muted">{{ details.size | prettyBytes }}</small>
      </div>
      <div class="col-md-2 text-right">
        <span class="align-middle">
          <button
            v-if="downloadButton"
            class="btn btn-primary mr-2 btn-xs"
            type="button"
            @click="download"
          >
            <i class="fas fa-download"></i>
          </button>
          <button
            v-if="removeButton"
            type="button"
            class="btn btn-danger btn-xs"
            @click="$emit('remove')"
          >
            <i class="far fa-trash-alt"></i>
          </button>
        </span>
      </div>
    </div>
  </b-card>
</template>

<script>
export default {
  name: "attachment",
  props: {
    details: {
      type: Object,
      required: true,
    },
    downloadButton: {
      type: Boolean,
      default: true,
    },
    removeButton: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    download() {
      if (this.details.url === null) {
        window.open(
          this.details.download +
            "?token=" +
            localStorage.getItem("token_suporte"),
          "_blank"
        );
      } else {
        window.open(this.details.download, "_blank");
      }
    },
  },
};
</script>
